import * as Yup from 'yup'
import {
  format as fnsFormat,
  differenceInYears,
  isFuture,
  addDays,
  isPast,
} from 'date-fns'

Yup.addMethod(
  Yup.string,
  'formatOfDate',
  function formatOfDate(formats, dateSeperator, message) {
    // need to be string for custom error message
    return this.test('testFormat', message, function testFormat(value) {
      if (value) {
        const date = value.split(dateSeperator).map((val) => parseInt(val, 10))
        return (
          value === fnsFormat(new Date(date[2], date[1] - 1, date[0]), formats)
        )
      }
      return true
    })
  }
)
Yup.addMethod(
  Yup.string,
  'fullAge',
  function fullAge(years, dateSeperator, message) {
    // need to be string for custom error message
    return this.test('testAge', message, function testAge(value) {
      if (value) {
        const date = value.split(dateSeperator).map((val) => parseInt(val, 10))
        return (
          differenceInYears(
            new Date(),
            new Date(date[2], date[1] - 1, date[0])
          ) >= years
        )
      }
      return true
    })
  }
)
Yup.addMethod(
  Yup.string,
  'notInFuture',
  function notInFuture(dateSeperator, message) {
    // need to be string for custom error message
    return this.test('testAge', message, function testAge(value) {
      if (value) {
        const date = value.split(dateSeperator).map((val) => parseInt(val, 10))
        return !isFuture(new Date(date[2], date[1] - 1, date[0]))
      }
      return true
    })
  }
)
Yup.addMethod(
  Yup.string,
  'notInPast',
  function notInPast(dateSeperator, message) {
    // need to be string for custom error message
    return this.test(
      'testDateNotInPast',
      message,
      function testDateNotInPast(value) {
        if (value) {
          const dateArr = value
            .split(dateSeperator)
            .map((val) => parseInt(val, 10))
          const date = addDays(
            new Date(dateArr[2], dateArr[1] - 1, dateArr[0]),
            1
          )
          return !isPast(date)
        }
        return true
      }
    )
  }
)
Yup.addMethod(
  Yup.string,
  'minValue',
  function minValue(message, minValueParam) {
    return this.test('testMin', message, function testMin(value) {
      if (!value) {
        return true
      }
      return parseFloat(value.replace(/,/g, '.')) >= minValueParam
    })
  }
)
Yup.addMethod(
  Yup.string,
  'maxValue',
  function maxValue(message, maxValueParam) {
    return this.test('testMax', message, function testMax(value) {
      if (!value) {
        return true
      }
      return parseFloat(value.replace(/,/g, '.')) <= maxValueParam
    })
  }
)
Yup.addMethod(
  Yup.string,
  'atLeastOneOf',
  function atLeastOneOf(list: string[], message) {
    return this.test(
      'testAtLeastOneOf',
      message,
      function testAtLeastOneOf(value) {
        if (value === undefined) {
          return list.some((item) => this.parent[item] !== undefined)
        }
        return true
      }
    )
  }
)
Yup.addMethod(Yup.string, 'validateNif', function validateNif(message) {
  return this.test(
    'testNif',
    message,
    function testNif(nif: string | undefined) {
      if (!nif) return true
      let sum = 0
      let control = 0
      if (nif.length === 9) {
        sum =
          Number(nif[7]) * 2 +
          Number(nif[6]) * 3 +
          Number(nif[5]) * 4 +
          Number(nif[4]) * 5 +
          Number(nif[3]) * 6 +
          Number(nif[2]) * 7 +
          Number(nif[1]) * 8 +
          Number(nif[0]) * 9

        const mod = sum % 11
        if (mod !== 0 && mod !== 1) {
          control = 11 - mod
        }
        if (parseInt(nif[8], 10) === control) {
          return true
        }
      }
      return false
    }
  )
})

export default Yup
